
  import { defineComponent } from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import InputBlock from '@/common/components/redesigned/InputBlock.vue';
  import SelectMultiComponentCheckbox from '@/common/components/redesigned/SelectRedesigned/SelectMultiComponentCheckbox.vue';
  import SelectMultiComponent from '@/common/components/SelectMultiComponent.vue';

  import { DASHBOARDS_VES_ACTIONS_NAME, DASHBOARDS_VES_GETTERS_NAME } from '../../store/dashboards/name';
  import { TEventsTableFilter } from '../../types/dashboards';

  import { DIRECTIVES_ACTIONS_NAME, DIRECTIVES_GETTERS_NAME } from '@/store/directives';

  export default defineComponent({
    name: 'EventsTableFilters',
    components: { InputBlock, SelectMultiComponent, SelectMultiComponentCheckbox, ComponentInput },
    props: {
      hideSubjectFilter: {
        type: Boolean,
        default: false,
      },
      hideCountryFilter: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['change'],
    data(): { filter: TEventsTableFilter } {
      return {
        filter: {},
      };
    },
    created() {
      this.fetchFilters();
    },
    computed: {
      ...mapGetters({
        eventTypes: DASHBOARDS_VES_GETTERS_NAME.getEventTypes,
        regionsList: DIRECTIVES_GETTERS_NAME.getRegionsSearchIdList,
        partnerCountryList: DIRECTIVES_GETTERS_NAME.getPartnerCountrySearchIdList,
      }),
    },
    watch: {
      filter: {
        deep: true,
        handler: 'onFilterChange',
      },
    },
    methods: {
      ...mapActions({
        getEventTypes: DASHBOARDS_VES_ACTIONS_NAME.getEventTypes,
        getRegionsSearchId: DIRECTIVES_ACTIONS_NAME.getRegionsSearchId,
        getPartnerCountrySearchId: DIRECTIVES_ACTIONS_NAME.getPartnerCountrySearchId,
      }),
      onFilterChange(value: TEventsTableFilter) {
        this.$emit('change', { ...value });
      },
      fetchFilters() {
        this.getEventTypes();
        this.getRegionsSearchId();
        this.getPartnerCountrySearchId();
      },
    },
  });
